import { defineComponent as _defineComponent } from 'vue'
import Translations from "@/models/Localization/Translations";
import { Nutritions} from "@/models/Recipes/Nutritions";
import { NutritionCountry} from "@/models/NutritionLabels/NutritionCountry";
import VNutritionLabel from "@/components/vNutritionLabel.vue";
import NutritionLabelRepository from "@/utils/API/NutritionLabelRepository";
import { useAwaitFetch} from "@/hooks/useAwaitFetch";
import { MethodResult} from "@/utils/API/ResultTypes/MethodResult";
import { CalculationMethodModalData} from "@/models/Recipes/CalculationMethodModalData";
import { RoundingRules} from "@/models/NutritionLabels/RoundingRules";
import { NutritionLabelCountry } from "@/models/NutritionLabels/NutritionLabelCountry";
import { computed } from "vue";
import vSelect from "@/components/vSelect.vue";
import VPreLoader from "@/components/vPreLoader.vue";

type vPreviewLabelProps = {
  recipeId: number,
  servingCount: number,
  translations: Translations,
  isTrial: boolean,
  nutritionAnalysis: Nutritions,
  isDirty: boolean,
  selectedCountry: NutritionCountry,
  selectedRoundingRule: RoundingRules,
  calculationMethodModel: CalculationMethodModalData,
  roundingRuleOptions: RoundingRules[],
  isSupplementLabelLoaded: boolean,
  isSupplementLabel: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'vPreviewLabel',
  props: {
    recipeId: { default: null },
    servingCount: { default: 1 },
    translations: null,
    isTrial: { type: Boolean },
    nutritionAnalysis: null,
    isDirty: { type: Boolean, default: false },
    selectedCountry: null,
    selectedRoundingRule: null,
    calculationMethodModel: null,
    roundingRuleOptions: null,
    isSupplementLabelLoaded: { type: Boolean },
    isSupplementLabel: { type: Boolean }
  },
  emits: ['calculate-nutrition', 'update-country', 'update-rounding-index'],
  setup(__props: any, { emit }) {

const props = __props as { recipeId: number, servingCount: number, translations: Translations, isTrial: boolean, nutritionAnalysis: Nutritions, isDirty: boolean, selectedCountry: NutritionCountry, selectedRoundingRule: RoundingRules, calculationMethodModel: CalculationMethodModalData, roundingRuleOptions: RoundingRules[], isSupplementLabelLoaded: boolean, isSupplementLabel: boolean };





const isSupplementLabelSelected = computed({
  get() {
    return props.isSupplementLabel;
  },
  set(newValue: boolean) {
    emit('update-country', props.selectedCountry, newValue);
  }
});

const isUsCountry = computed(() => props.selectedCountry?.id === NutritionLabelCountry.US);
const isSupplementDisabled = computed(() => (
  isUsCountry.value && [1, 2].includes(props.selectedRoundingRule?.id || 0)
));

const toRuleId = (rule: RoundingRules) => rule.id;

const { data, loading } = useAwaitFetch<MethodResult<NutritionCountry[]>>(
  NutritionLabelRepository.listNutritionCountries()
);

function updateRoundingRuleIndex(newIndex: RoundingRules) {
  if (isUsCountry.value && [1, 2].includes(newIndex.id)) {
    isSupplementLabelSelected.value = false;
  }

  emit('update-rounding-index', newIndex);
}

function getCountryName() {
  return props.selectedCountry ? props.selectedCountry.name : null;
}

const onCountryChange = (country: NutritionCountry) => {
  emit('update-country', country, false);
  updateRoundingRuleIndex({ id: 0, name: 'FDA' });
};


return { __sfc: true,props, emit, isSupplementLabelSelected, isUsCountry, isSupplementDisabled, toRuleId, data, loading, updateRoundingRuleIndex, getCountryName, onCountryChange, VNutritionLabel, NutritionLabelCountry, vSelect, VPreLoader }
}

})